module.exports = __webpack_public_path__ + "static/media/nexter_medium.b6f10563.jpg";